module.exports = __webpack_public_path__ + "static/media/paris-final4.8e5df7d6.png";